import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import Share from 'vue-social-share'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/normalize.css'
import './assets/client.css';
import './icons'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Share)

Vue.prototype.$scrollTo = (x = 0, y = 0, type = 'smooth') => {
	window.scrollTo({
		top: x,
		left: y,
		behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
	})
}

new Vue({
	router,
  store,
	render: h => h(App)
}).$mount('#app')
